var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIdsIcon = function SvgIdsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_x5F_card"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1801 449H247c-67 0-123 55-123 123v905c0 68 56 123 123 123h1554c68 0 123-55 123-123V572c0-68-55-123-123-123zm-7 1021H254V579h1540v891z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M703 1024a316 316 0 0 0-317 317h633c0-175-141-317-316-317z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 703,
    cy: 857,
    r: 157
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1600 1212h-253c-35 0-63 28-63 62 0 35 28 63 63 63h253a63 63 0 1 0 0-125zM1212 1080h388c34 0 63-28 63-62 0-35-29-63-63-63h-388a63 63 0 1 0 0 125zM1212 824h388a63 63 0 1 0 0-125h-388c-34 0-62 28-62 62 0 35 28 63 62 63z"
  }))));
};
export default __webpack_public_path__ + "static/media/IDS_icon.dc672977.svg";
export { SvgIdsIcon as ReactComponent };